<template>
  <div class="container">
    <dashboardHeader>
    </dashboardHeader>
    <div class="card">
      <div class="card-body">
        <div class="row mb-4">
          <div class="col-6">
            <a
              href="#"
              @click="option = 0"
              :class="[option == 0 ? 'active' : '']"
              >Alterar emails</a
            >
          </div>
          <div class="col-6">
            <a
              href="#"
              @click="option = 1"
              :class="[option == 1 ? 'active' : '']"
              >Alterar senha</a
            >
          </div>
        </div>

        <form action="" method="post" @submit="checkPasswordForm">
          <div v-if="option == 0" class="row justify-content-center text-left">
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label for="userEmail">Email de acesso:</label>
                <input
                  id="userEmail"
                  class="form-control"
                  type="email"
                  v-model="user.email"
                  required
                />
              </div>
            </div>
            <div class="w-100"></div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label for="billingEmail">Email financeiro:</label>
                <input
                  id="billingEmail"
                  class="form-control"
                  type="email"
                  v-model="user.billing_email"
                />
              </div>
            </div>
            <div class="w-100"></div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label for="password"
                  >Insira sua senha para confirmar essa ação:</label
                >
                <input
                  id="password"
                  class="form-control"
                  type="password"
                  v-model="password"
                  required
                />
              </div>
            </div>
            <div class="w-100"></div>
            <div class="col-12 col-md-6">
              <p v-if="error" class="error">
                {{ error }}
              </p>
              <input
                class="btn btn-block btn-franchise"
                type="submit"
                value="Salvar"
              />
            </div>
          </div>
        </form>

        <form action="" method="post" @submit="checkEmailForm">
          <div v-if="option == 1" class="row justify-content-center text-left">
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label for="newPassword">Nova senha:</label>
                <input
                  id="newPassword"
                  class="form-control"
                  type="password"
                  v-model="newPassword"
                  required
                />
              </div>
            </div>
            <div class="w-100"></div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label for="password"
                  >Insira sua senha para confirmar essa ação:</label
                >
                <input
                  id="password"
                  class="form-control"
                  type="password"
                  v-model="password"
                  required
                />
              </div>
            </div>
            <div class="w-100"></div>
            <div class="col-12 col-md-6">
              <p v-if="passwordError" class="error">
                {{ passwordError }}
              </p>
              <input
                class="btn btn-block btn-franchise"
                type="submit"
                value="Salvar"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserDataPage",
  data() {
    return {
      user: {
        billingEmail: null,
        email: null,
      },
      password: null,
      newPassword: null,
      option: 0,
      error: "",
      passwordError: "",
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.user);
    // this.user.billingEmail = JSON.parse(localStorage.user.billingEmail);
  },
  components: {
    dashboardHeader: () => import("@/components/molecules/DashboardHeader.vue"),
  },
  methods: {
    checkPasswordForm(e) {
      this.saveEmail();
      e.preventDefault();
    },
    checkEmailForm(e) {
      this.savePassword();
      e.preventDefault();
    },
    async saveEmail() {
      this.error = "";
      let postdata = {
        email: this.user.email,
        billingEmail: this.user.billing_email,
        password: this.password,
      };

      var result = await this.$run_axios(
        "post",
        "/user/email/update",
        postdata
      );

      if (result) {
        if (result.status == 1) {
          localStorage.user = JSON.stringify(this.user);
          this.$router.push("/dashboard");
        } else {
          this.error = result.message;
        }
      }
    },
    async savePassword() {
      this.passwordError = "";
      let postdata = {
        password: this.password,
        newPassword: this.newPassword,
      };

      var result = await this.$run_axios(
        "post",
        "/user/password/update",
        postdata
      );

      if (result) {
        if (result.status == 1) {
          this.$router.push("/dashboard");
        } else {
          this.passwordError = result.message;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
